import { ObjectionsModelRequest } from '../api/Argentia/endpoints/objections/model/objections'
import { ObjectionTableModel } from '../pages/invoicesPage/invoicesPage.Model'

export const mapObjectionTableModelToObjectionModel = (
  tableModel: ObjectionTableModel
): ObjectionsModelRequest => {
  return {
    id: tableModel.id,
    idObjMaestra: tableModel.idObjMaestra,
    state: tableModel.state,
    comments: tableModel.comments,
    invoiceID: 0, // should be set after mapping if it is an invoice objection
    documentID: 0, // should be set after mapping if it is a document objection
    settlementID: 0, // should be set after mapping if it is a settlement objection
    settlementBatchID: 0 // should be set after mapping if it is a settlement batch objection
  }
}
